const RELOAD_KEY = '__eb_chunk_reload';

/** Reloads the page once per session to recover from a stale chunk after a redeploy. */
export function reloadOnceForStaleChunk(): void {
  if (sessionStorage.getItem(RELOAD_KEY)) return;
  sessionStorage.setItem(RELOAD_KEY, '1');
  window.location.reload();
}
